export const header = {
	h1: `我的邀请链接`,
	h2: `立即复制`,
	h3: `邀请地址`,
	h4: `绑定地址`,
	h5: `生态`,
	h6: `分享链接`,
	h7: `状态`,
	h8: `未激活`,
	h9: `已激活`,
	h10: `首页`,
	h11: `系统公告`,
	h12: `OIS价格`,
	h13: `分享好友`,
	h14: `布道池`,
	h15: `挖矿算力`,
	h16: `我的社区`,
	h17: `审计报告`,
	h18: `元宇宙`,
	h19: `游戏`,
	h20: `已复制`,
	h21: `确认`,
	h22: `敬请期待`,
	h23: `绑定成功`,
	h24: `正在绑定关系请耐心等待（5-10）秒...`,
	h25: `矿池`,
	h26: `我的`,
	h27: "下拉即可刷新...",
	h28: "释放即可刷新...",
	h29: "加载中...",
	h30: "没有更多了!!",
	h31: "设置登录密码",
	h32: "请输入登录密码",
	h33: "请确认登录密码",
	h34: "登录密码",
	h35: "重置登录密码",
	h36: "设置交易密码",
	h37: "重置交易密码",
	h38: "社区节点",
	h39: "超级节点",
	h40: "登录成功",
	h41: "登录密码不能为空",
	h42: "确认密码不能为空",
	h43: `请设置6位字母＋数字+密码`,
	h44: `请确认您的密码`,
	h45: `登录密码错误，请重试！！`,
	h46: `用户不存在`,
	h47: `忘记密码`,
	h48: `刷新成功`,
	h49: `绑定失败，请检查`,
	h51: `请输入正确的绑定地址`,
	h52: `修改密码`,
	h53: `请输入新密码`,
	h54: `请确认新密码`,
	h55: `请输入谷歌验证码`,
	h56: `确认`,
	h57: `谷歌验证码错误`,
	h58: `请输入登录密码`,
	h59: `解绑谷歌验证`,
	h60: `提现成功，请等待审核`,
	h61: `交易密码错误`,
	h62: `用户不存在`,
	h63: `用户未绑定谷歌验证！`,
	h64: `领取成功`,
	h65: `用户资产不存在`,
	h66: `webc资产不足`,
	h67: `USDT资产不足`,
	h68: `抽奖`,
	h69: `卡牌不存在`,
	h70: `质押成功`,
	h71: `卡片数量小于输入数量！！`,
	h72: `交易密码错误，请重试！！`,
	h73: `请输入卡片数量 或者卡片不能小于等于0`
}
export const goodle = {
	"a0": "绑定谷歌验证",
	"a1": "下载APP",
	"a2": "扫描二维码",
	"a3": "备份密钥",
	"a4": "绑定谷歌验证",
	"a5": "成功",
	"a6": "下载并安装身份验证APP",
	"a7": "谷歌验证器",
	"a8": "如何使用谷歌身份验证器",
	"a9": "下一步",
	"a10": "用谷歌验证APP扫描这个二维码",
	"a11": "如果您无法扫描这个二维码,请在APP中手动输入这串字符。",
	"a12": "上一步",
	"a13": "将密钥备份后保存在安全位置",
	"a14": "若您丢失手机,此密钥可用来恢复您的身份验证器,",
	"a15": "客服帮您重置谷歌验证器至少需要7天。",
	"a16": "绑定谷歌验证器前需要验证您的账户",
	"a17": "请输入谷歌验证器的6位验证码",
	"a18": "安全验证不可用?",
	"a19": "身份验证器已绑定",
	"a20": "您已成功绑定身份验证器来保护您的账户",
	"a21": "返回",
	"a22": "解绑",
	"a23": "您确定要解绑谷歌验证器吗?",
	"a24": "为了保护您的资产安全，解绑验证后该账户将禁用支付服务，提币和C2C卖币24小时，以确保您的账户安全。",
	"a25": "取 消",
	"a26": "确 定",
	"a27": "解绑谷歌验证器",
	"a28": "安全验证",
	"a29": "谷歌验证码",
	"a30": "谷歌验证器APP将保护您的账户和提现功能。",
	"a31": "更改谷歌验证器"
}
export const card = {
	a1: "钱包余额",
	a2: "充值",
	a3: "提现",
	a4: "我的NFT",
	a5: "我的SNFT",
	a6: "抽奖记录",
	a7: "抽取卡牌",
	a8: "很遗憾未中奖！",
	a9: "恭喜您中奖！",
	a10: "获得",
	a11: "奖励",
	a12: "暂无数据",
	a13: "请输入金额",
	a14: "取消",
	a15: "确定",
	a16: "正在授权请耐心等待（5-10）秒...",
	a17: "输入密码",
	a18: "请输入密码",
	a19: "钱包余额不足，购买失败",
	a20: "恭喜您合成",
	a21: "很遗憾您未中奖",
	a22: "您已连续点击弹窗",
	a23: "请",
	a24: "60秒",
	a25: "后再次开启",
	a26: "您已达到当日最高抽取",
	a27: "获得",
	a28: "盲盒数量",
	a29: "个",
	a30: "刷新成功",
	a31: "请输入密码",
	a32: "请输入金额",
	a33: "授权额度查询",
	a34: "合约钱包余额",
	a35: "合约授权",
	a36: "合约余额不足",
	a37: "待区块反应",
	a38: "请先登录",
	a39: "我的卡牌",
	a40: "SNFT合成",
	a41: "注意：每合成一张SNFT只能选择一张UNFT",
	a42: "张",
	a43: "去合成",
	a44: "我的SNFT",
	a45: "合成记录",
	a46: "不满足9＋1的合成模式",
	a47: "恭喜您合成",
	a48: "合成一张",
	a49: "请勾选星球卡牌",
	a50: "共",
	a51: "恭喜获得",
}
export const orePond = {
	a1: "矿池一",
	a2: "矿池二",
	a3: "矿池三",
	a4: "矿池四",
	a5: "天",
	a6: "收益",
	a7: "算力",
	a8: "可用额度",
	a9: "存入金额",
	a10: "LP收益",
	a11: "质押",
	a12: "赎回",
	a13: "共",
	a14: "张",
	a15: "批准",
	a16: "已批准",
	a17: "质押数量",
	a18: "赎回数量",
	a19: "请输入数量",
	a20: "输入密码",
	a21: "请输入密码",
	a22: "钱包余额不足，购买失败",
	a23: "获得",
	a24: "张",
	a25: "卡牌",
	a26: "支付",
	a27: "规则/权益",
	a28: "一星节点",
	a29: "二星节点",
	a30: "三星节点",
	a31: "请先设置密码",
	a32: "我的UNFT",
	a33: "购买",
	a34: "我的",
	a35: "赠送记录",
	a36: "规则/权益",
	a37: "价格",
	a38: "全网销毁量",
	a39: "去挖矿",
	a40: "卡片挖矿",
	a41: "消费挖矿",
	a42: "暂未开放",
	a43: "购买记录",
	a44: "限量",
	a45: "我的WEBC",
	a46: "节点",
	a47: "枚",
	a48: "每个地址限购1份，售完即止。",
}
export const myself = {
	"a0": "认购",
	"a1": "我的资产",
	"a2": "我的社区",
	"a3": "邀请好友",
	"a4": "我的密码",
	"a5": "我的交易",
	"a6": "OTC交易",
	"a7": "战略合作伙伴",
	"a8": "邀请好友",
	"a9": "快来邀请好友一起加入吧",
	"a10": "我的推广码",
	"a11": "交易",
	"a12": "购买",
	"a13": "出售",
	"a14": "估价",
	"a15": "数量",
	"a16": "请输入数量",
	"a17": "取 消",
	"a18": "确 定",
	"a19": "输入密码",
	"a20": "请输入密码",
	"a21": "钱包余额不足，购买失败",
	"a22": "请输入密码",
	"a23": "复制成功",
	"a24": "请先登录",
	"a25": "我的资产",
	"a26": "充值",
	"a27": "提取",
	"a28": "我的NFT",
	"a29": "星系NFT",
	"a30": "我的SNFT",
	"a31": "我的UNFT",
	"a32": "我的收益",
	"a33": "收益 WEBT",
	"a34": "领取",
	"a35": "领取到余额需扣20%的WEBC",
	"a36": "收益分类",
	"a37": "WEBT记录",
	"a38": "挖矿收益",
	"a39": "产出WEBC：",
	"a40": "余额",
	"a41": "我的社区",
	"a42": "社区总业绩USDT",
	"a43": "我的等级：",
	"a44": "直推人数：",
	"a45": "直推列表",
	"a46": "社区成员一",
	"a47": "社区成员二",
	"a48": "社区成员三",
	"a49": "我的收益",
	"a50": "抽奖收益",
	"a51": "获得",
	"a52": "奖励",
	"a53": "分享收益",
	"a54": "我的密码",
	"a55": "设置密码",
	"a56": "重置密码",
	"a57": "获取签名",
	"a58": "已获取签名",
	"a59": "请输入旧密码",
	"a60": "请设置6位字母＋数字支付密码",
	"a61": "请确认您的支付密码",
	"a62": "完成",
	"a63": "获取成功",
	"a64": "请先获取签名",
	"a65": "两次密码输入不一致",
	"a66": "设置成功",
	"a67": "OTC交易",
	"a68": "购买",
	"a69": "出售",
	"a70": "请选择",
	"a71": "估价",
	"a72": "数量",
	"a73": "USDT余额",
	"a74": "WEBC余额",
	"a75": "温馨提示：买卖费用的1％WEBC",
	"a76": "输入密码",
	"a77": "请输入密码",
	"a78": "钱包余额不足，购买失败",
	"a79": "请输入数量",
	"a80": "请输入密码",
	"a81": "星系NFT",
	"a82": "水星",
	"a83": "共十张",
	"a84": "火星",
	"a85": "金星",
	"a86": "土星",
	"a87": "木星",
	"a88": "我的UNFT",
	"a89": "我的收益",
	"a90": "抽奖收益",
	"a91": "获得木星奖励",
	"a92": "分享收益",
	"a93": "USDT记录",
	"a94": "USDT分享收益",
	"a95": "时间",
	"a96": "奖励",
	"a97": "地址",
	"a98": "来源",
	"a99": "分享",
	"a100": "成交中，请等待！",
	"a101": "可用USDT不足！无法购买！",
	"a102": "可用webc不足！无法购买！",
	"a103": "可用Snft不足！无法出售！",
	"a104": "可用webc不足！无法出售！",
	"a105": "购买完成请耐心等待",
	"a106": "业绩",
	"a107": "请确定密码",
	"a108": "节点"
}
export const home = {
	h1: `OIS全网总算力`,
	h2: `OIS全网总销毁`,
	h3: `OIS每日最高产量`,
	h4: `OIS总发行量`,
	h5: `LP池`,
	h6: `（暂未开放）`,
	h7: `质押挖矿`,
	h8: `单币池`,
	h9: `组合池`,
	h10: `获得OIS收益`,
	h11: `获得USDT收益`,
	h12: `提币`,
	h13: `合作伙伴`,
	h14: `绿洲是一个集DEFI、NET、元宇宙、链游等`,
	h15: `多融性的去中心化平台`,
	h16: `350%封顶轮回`
}
export const miningIncome = {
	m1: `布道池挖矿收益`,
	m2: `每日产出总量（OIS）`,
	m3: `布道池产出（OIS）`,
	m4: `个人算力`,
	m5: `挖矿收益`,
	m6: `分享收益（USDT）`,
	m7: `分享算力`,
	m8: `可提币总数（USDT）`,
	m9: `可提币总数（OIS）`,
	m10: `提取OIS收益`,
	m11: `提取USDT收益`,
	m12: `提示`,
	m13: `可提取数量：`,
	m14: `提取`,
	m15: `取消`,
	m16: `已提交，请等待区块确认`,
}
export const pushStraight = {
	p1: `我的直推列表`,
	p2: `地址`,
	p3: `暂无推荐地址`,
	p4: `已推荐`,
	p5: `个`,
	p6: `复制`,
	p7: `该地址直推列表`,
	p8: `确认`,
}
export const vip = {
	v1: `我的等级`,
	v2: `挖矿收益`,
	v3: `VIP 获取`,
	v4: `总需`,
	v5: `购买`,
	v6: `批准`,
	v7: `说明`,
	v8: `V5封顶轮回了，V6才会点亮，V6封顶轮回了，V7才能点亮`,
	v9: `不能小于或等于当前等级`,
	v10: `已提交，请等待区块确认`,
	v11: `授权中，请等待区块确认`,
	v12: `确认中，请等待`,
	v13: `授权成功`,
	v14: `請勿重複購買`,
	v15: `不能购买小于当前等级的vip`,
}
export const Kp = {
	a0: `转账`,
	a1: `闪兑`,
	a2: `闪兑记录`,
	a3: `时间`,
	a4: `地址`,
	a5: `数量`,
	a6: `请输入收款地址`,
	a7: `请输入数量`,
	a8: `消耗`,
	a9: `恭喜您中奖NFT`,
	a10: `SNFT抽取算力`,
	a11: `USDT记录`,
	a12: `收益USDT`,
	a13: `抽奖获取SNFT算力`,
	a14: "地址不能为空或者为0",
	a15: "数量不能为空或者为0",
	a16: "接收方用户不存在/或者接收方不是自己的下级！",
	a17: "转账成功",
	a18: "钱包额度不足",
	a19: "当前用户不存在",
	a20: "交易密码错误",
	a21: "转账金额不能小于等于0",
	a22: `用户没有对应的SNFT`,
	a23: `请输入地址`,
	a24: `请输入闪兑数量`,
	a25: `闪兑数量不能小于等于0`,
	a26: `用户不存在`,
	a27: `闪兑成功`,
	a28: `请输入交易密码`,
	a29: `交易密码错误`,
	a30: `用户没有足够的SNFT进行闪兑`,
	a31: `类型`,
	a32: `接收方用户不存在`,
	a33: `银河SNFT`,
	a34: `太空SNFT`,
	a35: `宇宙SNFT`,
	a36: `可用数量`,
	a37: `张`,
	a38: `获得`,
	a39: `确定`,
	a40: `历史记录`,
	a41: `充值`,
	a42: `提币`,
	a43: `转账`,
	a44: `闪兑`,
	a45: `地址1`,
	a46: `地址2`,
	a47: `申请中`,
	a48: `审核通过`,
	a49: `审核拒绝`,
	a50: `币种`,
	a51: `转账记录`,
	a52: `NFT游戏`,
	a53: `恭喜您获得算力`,
	a54: `倍`,
	a55: `创世节点`,
	a56: `进行中`,
	a57: `已完成`,
	a58: `撤销`,
	a59: '出售',
	a60: `购买`,
	a61: `买卖清单`,
	a62: `操作`,
	a63: `方向`,
	a64: `金额`,
	a65: `等待成交`,
	a66: `部分成交`,
	a67: `全部成交`,
	a68: `取消`,
	a69: `是否取消订单？`,
	a70: `Otc订单不存在`,
	a71: `Otc订单已经全部成交，或成交数量已经为0`,
	a72: `取消otc订单成功`,
	a73: "矿池1",
	a74: "矿池2",
	a75: "矿池3",
	a76: "矿池4",
	a77: "销毁",
	a78: "此操作将去首页抽取SNFT盲盒是否确定？",
	a79: "矿池二全网算力",
	a80: "矿池二全网产出",
	a81: "矿池二个人算力",
	a82: "矿池二个人产出",
	a83: "提取",
	a84: "提取数量",
	a85: "请输入数量",
	a86: "请勿重复质押",
	a87: "正在质押请耐心等待（5-10）秒...",
	a88: "授权失败",
	a89: "质押成功",
	a90: "质押失败，请检查",
	a91: "链上质押失败",
	a92: "质押数量不能为小于0或者为空",
	a93: "质押数量必须小于等于可用余额",
	a94: "时间未到，禁止赎回",
	a95: "没有可赎回的，请先质押",
	a96: "赎回数量不能为空或者为0",
	a97: "赎回数量必须小于等于存入金额额",
	a98: "禁止点击，只允许赎回最大",
	a99: "赎回成功",
	a100: "赎回失败，请检查",
	a101: "链上赎回失败",
	a102: "正在赎回请耐心等待（5-10）秒...",
	a103: "购买成功",
	a104: "记录",
	a105: "USDT购买UNFT",
	a106: "UNFT向下转账-接收方",
	a107: "UNFT向下转账-发送方",
	a108: "请先升级为V1或以上等级",
	a109: "矿池一全网算力",
	a110: "矿池一全网产出",
	a111: "矿池一个人算力",
	a112: "矿池一个人产出",
	a113: "SNFT销毁抽取算力",
	a114: "选择销毁类型",
	a115: "选择盲盒类型",
	a116: "全网算力",
	a117: "全网产出",
	a118: "个人算力",
	a119: "个人产出",
	a120: "仅支持质押与赎回最大",
	a121: "仅支持最大提取",
	a122: "WEBC记录",
	a123: "购买UNFT没有开放",
	a124:"冻结余额",
	a125:"可用余额",
	a126:"冻结收益",
	a127:"算力余额",
	a128:"分类"
}
export const flowType = {
	"a0": "节点认购",
	"a1": "链上充值",
	"a2": "后台充值",
	"a3": "抽取卡牌-中奖",
	"a4": "抽取卡牌-消费",
	"a5": "抽奖返还-(没有中奖)",
	"a6": "抽奖收益-(没有中奖)",
	"a7": "推广奖励-管理级差奖",
	"a8": "推广奖励-直推奖",
	"a9": "卡牌合成-消费",
	"a10": "卡牌合成-成功",
	"a11": "节点认购-分红奖励",
	"a12": "otc购买下单-扣除可用Usdt",
	"a13": "otc购买下单-增加冻结Usdt",
	"a14": "otc购买下单-扣除手续费",
	"a15": "otc成交",
	"a16": "otc出售下单-扣除可用SNTF",
	"a17": "otc出售下单-扣除手续费",
	"a18": "领取我的收益",
	"a19": "用户申请提现",
	"a20": "矿池2号-挖矿收益",
	"a21": "销毁卡片获得算力",
	"a22": "提现-通过",
	"a23": "提现-拒绝",
	"a24": "矿池1号-挖矿收益",
	"a25": "UNFT向下转账-接收方",
	"a26": "UNFT向下转账-发送方",
	"a27": "用户兑换-WEBT兑换成USDT",
	"a28": "闪兑snft为WEBT",
	"a29": "提现USDT-扣除WEBC手续费",
	"a30": "提现WEBC-扣除WEBC手续费",
	"a31": "卡牌合成-手续费",
	"a32": "USDT向下转账-接收方",
	"a33": "USDT向下转账-发送方",
	"a34": "WEBC向下转账-接收方",
	"a35": "WEBC向下转账-发送方",
	"a36": "用户兑换-USDT兑换成WEBT",
	"a37": "结算收益减少算力",
	"a38": "WEBT向下转账-接收方",
	"a39": "WEBT向下转账-发送方",
	"a40": "otc取消订单",
	"a41": "otc取消出售订单-归还手续费",
	"a42": "otc取消出售订单-归还SNFT",
	"a43": "领取我的矿池一收益-增加资产",
	"a44": "领取我的矿池二收益-增加资产",
	"a45": "使用USDT购买UNFT",
	"a46": "销毁卡片",
	"a47": "质押LP",
	"a48": "质押LP获得算力",
	"a49": "领取我的矿池一收益-减少产出",
	"a50": "领取我的矿池二收益-减少产出",
	"a51": "行情"
}